import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Header.css';
const logo = '/assets/main/logo.png';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Get header class based on current route
  const getHeaderClass = () => {
    const path = location.pathname;
    if (path === '/') return 'header-home';
    if (path === '/devops') return 'header-devops';
    if (path === '/cloud') return 'header-cloud';
    if (path === '/data-science') return 'header-data-science';
    if (path === '/data-engineering') return 'header-data-engineering';
    if (path === '/generative-ai') return 'header-generative-ai';
    if (path === '/app-development') return 'header-app-development';
    return 'header-default'; // For contact and other pages
  };

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/devops', label: 'DevOps' },
    { path: '/cloud', label: 'Cloud' },
    { path: '/data-science', label: 'Data Science' },
    { path: '/data-engineering', label: 'Data Engineering' },
    { path: '/generative-ai', label: 'Generative AI' },
    { path: '/app-development', label: 'App Development' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <motion.header 
      className={`header ${isScrolled ? 'header-scrolled' : ''} ${getHeaderClass()}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <div className="container">
        <div className="header-content">
          <Link
            to="/"
            className="brand"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <img src={logo} alt="CloudRaize logo" className="brand-logo" />
            <span className="brand-name">CloudRaize</span>
          </Link>

          <nav className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <motion.span
                  whileHover={{ y: -2 }}
                  transition={{ duration: 0.2 }}
                >
                  {item.label}
                </motion.span>
              </Link>
            ))}
          </nav>

          <button
            className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;



